// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckboxField_container__rBkTX {
  display: flex;
  align-items: flex-end;
}

.CheckboxField_input__zILVB {
  border: solid 1px #666666;
  border-radius: 4px;
  margin-top: 8px;
  padding: 9px 16px;
}

.CheckboxField_input-curp__2g5pe {
  text-transform: uppercase;
}

.CheckboxField_error-text__l-KE4 {
  margin-top: 10px;
  color: #c9423c;
  font-size: 12px;
}

.CheckboxField_input-error__HSEKk {
  border: none;
  outline: solid 1px #c9423c;
}

.CheckboxField_input-error__HSEKk:focus-within {
  outline: none !important;
  border: solid 2px #c9423c;
}

.CheckboxField_input-error__HSEKk:focus {
  border-color: #c9423c;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/CheckboxField/CheckboxField.module.scss","webpack://./src/styles/_typography.scss","webpack://./src/styles/_colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,qBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,cAAA;EACA,eCtBO;ADoBT;;AAKA;EACE,YAAA;EACA,0BAAA;AAFF;;AAKA;EACE,wBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,qBEfM;AFaR","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.container {\n  display: flex;\n  align-items: flex-end;\n}\n\n.input {\n  border: solid 1px #666666;\n  border-radius: 4px;\n  margin-top: 8px;\n  padding: 9px 16px;\n}\n\n.input-curp {\n  text-transform: uppercase;\n}\n\n.error-text {\n  margin-top: 10px;\n  color: colors.$error;\n  font-size: typography.$body-s;\n}\n\n.input-error {\n  border: none;\n  outline: solid 1px colors.$error;\n}\n\n.input-error:focus-within {\n  outline: none !important;\n  border: solid 2px colors.$error;\n}\n\n.input-error:focus {\n  border-color: colors.$error;\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n","$neutral: #333333;\n$neutral-700: #252525;\n$accent: #054ab0;\n$primary: #ff6b00;\n$primary-hover: #c75004;\n$secondary: #1f1f1f;\n$secondary-hover: #393939;\n$default: #666666;\n$light: #616c7a;\n$white: #ffffff;\n$light-blue: #ebf3ff;\n$color-background-02: #f2f2f2;\n$color-background-text: #fbfbfb;\n$color-text-02: #333333;\n$color-text-disabled: #808080;\n$color-button-disabled: #e9e9e9;\n$color-semantic-primary: #e6e6e6;\n$color-success-active: #008863;\n$color-success-disable: #32d2a7;\n$color-error-active: #a63631;\n$color-error-disable: #ff9590;\n$error: #c9423c;\n$text-link: #0058e1;\n$text-link-hover: #003b9c;\n$neutral-200: #696969;\n$error-200: #d73a3d;\n$warning-200: #ffb93c;\n$info-200: #1175c9;\n$success-300: #4ba564;\n$neutral-400: #bbbbbb;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CheckboxField_container__rBkTX`,
	"input": `CheckboxField_input__zILVB`,
	"input-curp": `CheckboxField_input-curp__2g5pe`,
	"error-text": `CheckboxField_error-text__l-KE4`,
	"input-error": `CheckboxField_input-error__HSEKk`
};
export default ___CSS_LOADER_EXPORT___;
